import { AxiosInstance } from 'axios';
import { Paging } from '@Core';
import { BaseHttpController } from '@Core/controller/BaseHttpController';
import {
    CaseTypeVerificationRow,
    ConfidenceVerificationRow,
    RejectionReasonsResponse,
    TracksVolumeRow,
    VerificationCompleteRow,
    VerificationCounts,
    VerificationReportFilter,
    VerificationReportPagedFilter,
    ZoneVerificationPagedFilter,
    ZoneVerificationRow,
} from '../../api';
import { IPreprocessDashboardHttpController } from '../IPreprocessDashboardHttpController';

export class PreprocessDashboardHttpController
    extends BaseHttpController<{}>
    implements IPreprocessDashboardHttpController
{
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'v2/dashboard/tracks-verification', client);
    }

    async statusByContraventionDate(body: VerificationReportPagedFilter): Promise<Paging<TracksVolumeRow>> {
        return this.doPost({ path: 'status-by-contravention-date', body }).then((res) => res.data);
    }

    async rejectionReasons(body: VerificationReportFilter): Promise<RejectionReasonsResponse> {
        return this.doPost({ path: 'rejection-reasons', body }).then((res) => res.data);
    }

    async verifierProductivity(body: VerificationReportFilter): Promise<VerificationCompleteRow[]> {
        return this.doPost({ path: 'verifier-productivity', body }).then((res) => res.data);
    }

    async verificationOverview(body: VerificationReportFilter): Promise<VerificationCounts> {
        return this.doPost({ path: 'overview', body }).then((res) => res.data);
    }

    async trackClassificationBreakdown(body: VerificationReportFilter): Promise<CaseTypeVerificationRow[]> {
        return this.doPost({ path: 'track-classification-breakdown', body }).then((res) => res.data);
    }

    async trackClassificationByAiConfidence(body: VerificationReportFilter): Promise<ConfidenceVerificationRow[]> {
        return this.doPost({ path: 'track-classification-by-ai-confidence', body }).then((res) => res.data);
    }

    async zoneStatistics(body: ZoneVerificationPagedFilter): Promise<Paging<ZoneVerificationRow>> {
        return this.doPost({ path: 'zone-statistics', body }).then((res) => res.data);
    }
}
